<template>
  <Card :title="$t('global.ssl-certificate-status')">
    <LoadingState v-if="status.isLoading" />
    <ErrorState v-else-if="status.isErrored" />
    <div v-else-if="status.isLoaded">
      <!-- if no certificate is installed on this site -->
      <div v-if="!info.installed">
        <div>{{ $t("global.cert-not-installed-desc") }}</div>
        <h2 class="d-flex mt-4">
          <Icon icon="warning" color="gamma" :size="20" />
          <div class="pl-2">{{ $t("global.not-installed") }}</div>
        </h2>
      </div>

      <!-- if there is a certificate installed on this site -->
      <div v-else>
        <div>{{ $t("global.cert-installed-desc") }}</div>
        <h2 class="d-flex my-4">
          <Icon icon="success" color="gamma" :size="20" />
          <div class="pl-2">{{ $t("global.installed") }}</div>
        </h2>
        <CardListContent :list="getList()" />
      </div>
    </div>
  </Card>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CardListContent from "@/components/display/card-sub-components/CardListContent";
import { dateFormat } from "leatherman-js/utils/formatters/time";
import ErrorState from "@/components/display/ErrorState";
import Icon from "@/components/display/icon/Icon";
import LoadingState from "@/components/display/LoadingState";
import store from "@/store";

export default {
  name: "SSLInfo",
  components: {
    Card,
    Icon,
    LoadingState,
    ErrorState,
    CardListContent,
  },
  props: {
    site: Object,
  },
  setup(props, { root }) {
    const info = computed(() => store.getters["certificates/getCertInfo"]);
    const status = computed(() => store.getters["certificates/getCertInfoStatus"]);
    const loading = ref(true);

    const getList = () => {
      if (!info.value) {
        return [];
      }

      const { commonName, validTo, keyLength } = info.value;

      return [
        {
          label: root.$t("global.domain"),
          content: commonName,
          canCopy: true,
        },
        {
          label: root.$t("global.expiration"),
          content: dateFormat(validTo),
        },
        {
          label: root.$t("global.key-length"),
          content: `${keyLength} ${root.$t("global.bits")}`,
        },
      ];
    };

    onMounted(() => {
      // get info about this site's current certificate (if there is one installed)
      store.dispatch("certificates/getCertInfo", props.site.id).finally(() => {
        loading.value = false;
      });
    });

    return { info, loading, status, getList };
  },
};
</script>
